import * as Yup from 'yup';

export const otpVerificationSchema = Yup.object().shape({
    otp: Yup.string()
        .matches(/^\d+$/, 'Verification code must contain only numbers')
        .length(6, 'Your verification code must be six digit')
        .required('Please enter your six digit verification code')
});
